import { Typography } from "@mui/material";

import { useState } from "react";
import useAPI from "../../../../../../api/hooks/useAPI";
import useColors from "../../../../../../api/hooks/useColors";
import {
  getEntityTypeFromEntityId,
  isComplexEntityType,
} from "../../../../../../utils/utils";
import RemediationCollapseSection from "../../ControlRemediationDrawer/remediation/RemediationCollapseSection";
import {
  extractUniqueIdFromEntityId,
  getControlEntityIds,
} from "../../EntitiesSection/utils";
import {
  createFallbackSimpleEntitiesFromComplexIds,
  mergeEntitiesByType,
} from "../shared/entityFallbackUtils";
import MisconfiguredEntitiesSection from "./MisconfiguredEntitiesSection";

const groupSimpleEntitiesByType = (controlEntityIds) => {
  return controlEntityIds?.reduce((acc, entityId) => {
    const entityType = getEntityTypeFromEntityId(entityId);
    if (isComplexEntityType(entityType)) return acc;

    if (!acc[entityType]) {
      acc[entityType] = [];
    }
    acc[entityType].push({
      entity_id: entityId,
      display_name: extractUniqueIdFromEntityId(entityId),
      entity_type: entityType,
    });
    return acc;
  }, {});
};

const NonGroupedControlEntitiesSection = ({
  fullControl,
  complexEntitiesByType,
  defaultCollapsed = false,
}) => {
  const colors = useColors();
  const { trackEvent } = useAPI();

  const controlEntityIds = getControlEntityIds(fullControl);

  const fallbackSimpleEntities = createFallbackSimpleEntitiesFromComplexIds(
    controlEntityIds,
    complexEntitiesByType,
    fullControl.control_id,
    trackEvent,
    "entities not found in DB"
  );

  const simpleEntitiesByType = groupSimpleEntitiesByType(controlEntityIds);

  const allEntitiesByType = mergeEntitiesByType(
    complexEntitiesByType,
    simpleEntitiesByType,
    fallbackSimpleEntities
  );
  const [selectedEntityTypeTab, setSelectedEntityTypeTab] = useState(
    Object.keys(allEntitiesByType).length > 0
      ? Object.keys(allEntitiesByType)[0]
      : null
  );

  return (
    <RemediationCollapseSection
      title={
        Object.values(complexEntitiesByType).flat().length > 0
          ? "Who is affected?"
          : "What are the misconfigurations?"
      }
      defaultCollapsed={defaultCollapsed}
    >
      {Object.keys(allEntitiesByType).length > 0 ? (
        <MisconfiguredEntitiesSection
          fullControl={fullControl}
          allEntitiesByType={allEntitiesByType}
          selectedEntityTypeTab={selectedEntityTypeTab}
          setSelectedEntityTypeTab={setSelectedEntityTypeTab}
        />
      ) : (
        <Typography variant="body2" color={colors.primary} lineHeight="20px">
          Error loading this content...
        </Typography>
      )}
    </RemediationCollapseSection>
  );
};

export default NonGroupedControlEntitiesSection;
